import React from 'react';

function Wrapper(props) {
  return <>{props.children}</>;
}

export default Wrapper;
